import { render, staticRenderFns } from "./czy-icon.vue?vue&type=template&id=0c389696&"
import script from "./czy-icon.vue?vue&type=script&lang=js&"
export * from "./czy-icon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports